import React from 'react';
import Archive from '../products/Archive';

const Products = () => {
    return ( 
        <div>
            <Archive />
        </div>
     );
}
 
export default Products;